import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['slider', 'previousBtn', 'nextBtn'];

  connect() {
    this.itemWidth = this.sliderTarget.querySelector('.item-container').offsetWidth;
    this.containerWidth = this.sliderTarget.offsetWidth;
    this.itemsCount = this.sliderTarget.querySelectorAll('.item-container').length;

    this.handleUnsufficientItems();
  }

  handleUnsufficientItems() {
    if (this.containerWidth < this.itemsCount * this.itemWidth) return;

    this.sliderTarget.classList.add('w-max', 'mx-auto')
    this.previousBtnTarget.classList.add('md:hidden')
    this.nextBtnTarget.classList.add('md:hidden')
  }

  previousSlide(event) {
    if (this.sliderTarget.scrollLeft === 0) {
      this.sliderTarget.scrollLeft = this.sliderTarget.scrollWidth;
    } else {
      this.sliderTarget.scrollLeft -= this.itemWidth;
    }
  }

  nextSlide(event) {
    const maxScrollLeft = this.sliderTarget.scrollWidth - this.sliderTarget.clientWidth;
    if (this.sliderTarget.scrollLeft >= maxScrollLeft) {
      this.sliderTarget.scrollLeft = 0;
    } else {
      this.sliderTarget.scrollLeft += this.itemWidth;
    }
  }
}
